export default "__VITE_ASSET__Bkc1OTwc__"